import React, { FC } from "react";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GlobalStyles from "../styles/GlobalStyles";
import Avatar from '@material-ui/core/Avatar';
import InputBase from '@material-ui/core/InputBase';
import UserModel from '../models/user-model';
import { useSelector } from 'react-redux';
import Divider from '@material-ui/core/Divider';


const ImageHeaderComponet: FC = () => {
    const user: UserModel = useSelector((state: any) => state.authReducer.user)

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                margin: theme.spacing(1, 0, 1, 0),
            },
            large: {
                width: theme.spacing(7),
                height: theme.spacing(7),
                backgroundColor:GlobalStyles.primaryColor
            },
            textName: {
                padding: theme.spacing(1, 1, 0, 1)
            },
            textEmail: {
                padding: theme.spacing(0, 1, 0, 1),
                color: GlobalStyles.thirdColor
            },
            inputStyle: {
                textAlign: 'center',
                padding: "0px"
            }
        })
    );

    const classes = useStyles();
    return (
        <>
            <div className={classes.root}>
                <Avatar alt="Avatar" className={classes.large} >{(user.full_name.charAt(0)).toUpperCase()}</Avatar>
                <InputBase
                    value={user.full_name}
                    inputProps={{ style: { textAlign: 'center', padding: "0px" } }}
                    className={classes.textName}
                />
                <InputBase
                    value={user.email}
                    inputProps={{ style: { textAlign: 'center', padding: "0px" } }}
                    className={classes.textEmail}
                />
                <Divider />
            </div>
        </>
    );
};

export default ImageHeaderComponet;
